export const reportConstants = {
  GET_REPORT_SUCCESS: 'GET_REPORT_SUCCESS',
};
